import axios from 'axios';
import { createWizard } from 'clientside/wizard';
import 'protons';
import './_wizard-jobalert-subscription.twig';
import template from './template.vue';

export const name = 'wizard-jobalert-subscription';

export const defaults = {};

export function disable() {}

export function enable(context) {
  const el = context.querySelector('#wizard-jobalert-subscription');
  if (!el) return;

  const elConfig = JSON.parse(el.dataset.config);
  const { cities, jobs, apiendpoint } = elConfig;

  createWizard({
    el,
    name: 'Vacancies',
    template,
    async onSubmit({ data }) {
      const locations = [];
      data.city.cities.forEach((city) => {
        locations.push(...city.split('$$'));
      });

      let { mobilephone } = data.personal;
      if (data.personal.alertsms) {
        if (
          data.personal.mobilephone.indexOf('+49') !== 0 &&
          data.personal.mobilephone.indexOf('0049' !== 0)
        ) {
          mobilephone = mobilephone.replace(/^0?([1-9]?[0-9]+)$/, '+49$1');
        }
      }

      const bodyData = {
        contactRecords: {
          email: data.personal.email,
          phone: data.personal.alertsms ? mobilephone : undefined,
        },
        'job-positions': data.job.jobs,
        'job-locations': locations,
      };

      return new Promise((resolve, reject) => {
        axios
          .post(apiendpoint, bodyData)
          .then((response) => {
            if (response.status === 200 && response.data.success === true) {
              resolve();
            } else {
              reject(response.data.message);
            }
          })
          .catch((ex) => {
            reject(ex);
          });
      });
    },
    submitButtonLabel: 'Jetzt abonnieren',
    additionalOptionSets: {
      cities,
      jobs,
    },
    initialData: {
      city: {
        cities: ['all'],
      },
      job: {
        jobs: ['all'],
      },
    },
  });
}

export default enable;
